module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "ch-titlej"
  }, [_c('a', {
    attrs: {
      "id": "pagexiii"
    }
  }, [_vm._v("Introduction")])]), _c('a', {
    attrs: {
      "id": "pagexiii"
    }
  }), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "pagexiii"
    }
  }, [_vm._v("British Intelligence in the inter-war period was greatly under-resourced after the Military Intelligence Directorate was abolished in 1922 and merged with Military Operations. The Intelligence branch within the combined directorate dealt with matters of strategy but operational formations were expected to assign their own Intelligence staff from regimental officers, often with little specialist training. Major General Frederick ‘Paddy’ Beaumont-Nesbitt, head of the Intelligence branch, became head of a re-established Directorate of Military Intelligence in September 1939 and played a key role in overhauling Military Intelligence, including championing a small research unit in the War Office which originated as GS(R) and eventually became MI(R). It had been created in late 1938 as a small think-tank for irregular warfare but was dissolved in October 1940. The short history of MI(R) was intertwined with that of Section D of SIS and the two leaders, Jo Holland and Laurence Grand, worked in close partnership."), _c('sup', {
    staticClass: "sup"
  })]), _c('span', {
    attrs: {
      "href": "#/xhtml/Notes#rfnIn_1",
      "id": "fnIn_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")]), _vm._v(" In March 1939 these pioneers conceived an integrated plan of military and civilian guerrilla warfare and subversion which set the agenda for irregular warfare until the creation of SOE in July 1940. A Middle East equivalent, G(R), was formed in April 1940 under the general oversight of MI(R) but had a more operational focus. G(R) survived until September 1941 when it was finally absorbed by SOE. In the Far East elements survived until 1942, by which time former members of MI(R) were scattered amongst the new generation of special forces.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lieutenant Colonel Jo Holland was a visionary who created a blueprint for many aspects of clandestine warfare and was a key source of advice to the War Office during 1940. His imagination raced far ahead of the immediate crisis and in August 1940 Holland tried to persuade the Director of Military Intelligence that MI(R), re-orientated on research rather than operations in the field, should focus on developing the technology and tactics for STOL (short take off/landing) and helicopter-borne operations. Holland saw the role of MI(R) as being essentially one of research and was philosophical about the use made of its work which was more famously developed by others. He commented, ‘As you know, MI(R) has done a very considerable amount of work and has seen one idea after another evolved and taken away.’"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#rfnIn_2",
      "id": "fnIn_2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])]), _vm._v(" These ideas included the escape and evasion service (MI9) and the Commandos. MI(R) officer Quintin Hogg (Lord Hailsham) described it as ‘a clearing house "), _c('a', {
    attrs: {
      "id": "pagexiv"
    }
  }, [_vm._v("for bright ideas’."), _c('sup', {
    staticClass: "sup"
  })]), _c('span', {
    attrs: {
      "href": "#/xhtml/Notes#rfnIn_3",
      "id": "fnIn_3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")]), _vm._v(" Not all were happy with this altruistic attitude and there was a tension with Colin Gubbins, recruited in April 1939 as a major, who wanted a more active role. Gubbins was not given the chance in Norway to use the MI(R)-inspired Independent Companies in the guerrilla role for which they were intended but more surprisingly, given the reputation he was already acquiring as an expert in guerrilla warfare, he struggled to find a format for the GHQ Auxiliary Units in Britain.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("MI(R) was not structurally incorporated into SOE in the same way as Section D, although many former officers soon drifted into the new organization. Instead its sections were incorporated into other parts of Military Intelligence with the technical section MI(R)c most famously becoming ‘Churchill’s Toyshop’ in the new Ministry of Defence. Colin Gubbins became head of SOE in 1943 and one of his most significant contributions was to draw SOE back towards the original para-military concept preached by MI(R). His own ‘back story’, and that of MI(R), was then partially rewritten to suit his post-war legend. In 1948 Gubbins falsely claimed that ‘in 1940 when British forces were evacuated from Western Europe there was not a single contact of any kind with occupied Western Europe until somebody was dropped back there’."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#rfnIn_4",
      "id": "fnIn_4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])]), _vm._v(" He exaggerated when maintaining, in regard to training, ‘there was … practically nothing existing, just one explosives school and a dozen officers and civilians’. Thus ‘all had to be built up from scratch.’"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#rfnIn_5",
      "id": "fnIn_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Where antecedents to SOE were acknowledged by later historians they would frequently focus on Gubbins’ personal contribution to MI(R). Biographer A.R.B. Linderman unfairly maintained ‘Holland was thinking up clever projects and the men of Section D were chasing ghosts’, while it was Gubbins who was presented as having the more practical role."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#rfnIn_6",
      "id": "fnIn_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])]), _vm._v(" It was Gubbins who, in 1945, commissioned the first official history of SOE, although Mackenzie’s opus, completed in 1947, was not released for publication until 2000. This contained an extensive description of MI(R) but was completed shortly after SOE had been abolished and Gubbins, by now an acting major general, had been unceremoniously cast aside and retired on the pension of his substantive rank of colonel. Mackenzie blended official archives and oral testimony from key figures in SOE, dismayed by the treatment of their former leader, but it is not clear if he interviewed Laurence Grand of Section D and Jo Holland of MI(R); neither of them ever told their story in public. Unlike Gubbins, both retired with the substantive rank of major general. For Mackenzie, ‘MI(R) was successful as a research department largely because it was allowed to assume some executive responsibility. Its job (as construed by Colonel Holland) was not only to think up new schemes, but to drive them through the clogging medium of War Office discussion till they worked and stood on their own legs.’"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#rfnIn_7",
      "id": "fnIn_7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])]), _vm._v(" This was only partly true. Although firmly maintaining MI(R) was superior to Section D, both in technique and "), _c('a', {
    attrs: {
      "id": "pagexv"
    }
  }, [_vm._v("with its schemes having a ‘harder and more practical air’ (an aspect that the present study will question), Mackenzie also had to admit ‘It is impossible to claim that it [MI(R)] achieved much subversion, or that it left much organization on which SOE could build.’"), _c('sup', {
    staticClass: "sup"
  })]), _c('span', {
    attrs: {
      "href": "#/xhtml/Notes#rfnIn_8",
      "id": "fnIn_8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The driver in these early assessments was that, if SOE had any antecedents it had to be MI(R), in which Gubbins played a major role, and little credit was given to any branch of SIS, not helped by the fierce secrecy with which SIS surrounded any aspect of its work. In fact, it can be argued that MI(R) was less successful when it tried to compete with Section D in covert field operations, but this was not its intended role. Holland was trying to build a principle that irregular warfare should be driven by military strategy and led by soldiers, in contrast to the use of civilian agents and economic sabotage championed by Section D and the early SOE. Holland’s perspective was arguably the most successful in the long term, once Allied resources improved, but in 1940 MI(R)’s reliance on the cooperation of foreign General Staffs (on the naı¨ve assumption that they would automatically welcome British advice) was a fatal flaw.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The distortion in presentation was continued by M.R.D. Foot, who in his Preface to "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("SOE in France")]), _vm._v(" (1966) acknowledged the influence of Gubbins ‘who enabled me to call on his unrivalled recollections of what went on’."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#rfnIn_9",
      "id": "fnIn_9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])]), _vm._v(" Sadly, by then Holland was already dead and Grand followed the SIS tradition of silence. There was no equivalent memorial to Holland or Grand as that to Gubbins published in 1993 by his devoted followers, Peter Wilkinson and Joan Bright Astley, as "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Gubbins and SOE")]), _vm._v(" (1993), which established the tone for more modern, near hagiographical, studies. It was only in 2005 that Simon Anglim provided a more considered modern summary of the work of MI(R) and the present work is able to offer a more in-depth analysis of this pioneer of irregular warfare."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#rfnIn_10",
      "id": "fnIn_10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])]), _c('a', {
    attrs: {
      "id": "pagexvi"
    }
  })]), _c('a', {
    attrs: {
      "id": "pagexvi"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-46afe7d0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Introduction.vue
// module id = 84
// module chunks = 0